import Loadable from 'UIComponents/decorators/Loadable';
export default Loadable({
  loader: () => import( /* webpackChunkName: "asset-comment-button" */'./AssetCommentButton').then(mod => mod.default)
});